(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-order-tracking"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.country-tracking__form')) return;
    const input = form.elements.namedItem('nums');
    if (!(input instanceof HTMLInputElement)) return;
    event.preventDefault();
    const number = input.value.trim().replace(/\s+/g, '');
    if (!number) {
      input.value = '';
      input.reportValidity();
      return;
    }
    window.open('https://t.17track.net/sv#nums=' + encodeURIComponent(number), '_blank', 'noopener,noreferrer');
  });
  } catch(e) { console.error(e); }
})();

})();
